<template>
  <!-- Normal Search -->
  <div class="grid bg-white">
    <div class="row grid-body">
      <div class="col-md-2">
        <select
          class="form-control product-type"
          v-model="serverParams.productCategory"
        >
          <option
            v-for="productCategory in productCategories"
            :value="productCategory.value"
            :key="productCategory.value"
          >
            {{ productCategory.label }}
          </option>
        </select>
      </div>
      <div class="col-md-2">
        <select
          class="form-control product-type"
          v-model="serverParams.status"
        >
          <option
            v-for="status in productionStatutes"
            :value="status.value"
            :key="status.value"
          >
            {{ status.label }}
          </option>
        </select>
      </div>
      <div class="col-md-6">
        <button class="btn btn-success" @click="$emit('submit', true)">
          <i class="fa fa-search" aria-hidden="true"></i> Search
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["serverParams"],
  data() {
    return {
      productCategories: [
            { value: 'all' , label: 'All'},
            { value: 'curly', label: 'Curly'},
            { value: 'kellerfaltenbluse', label: 'Kellerfaltenbluse'},
            { value: 'hoodie', label: 'Hoodie'},
            { value: 'tshirts', label: 'T-Shirt'},
            { value: 'polos', label: 'Polo-Shirt'},
            { value: 'longsleeve', label: 'LongSleeve'},
            { value: 'handkerchief' , label: 'Handkerchief'}
        ],
      productionStatutes: [
        { value: 'all', label: 'All Statuses'},
        { value: 'imported', label: 'Imported'},
        { value: 'cutting', label: 'Cutting'},
        { value: 'stitching', label: 'Stitching'},
        { value: 'qc', label: 'QC'},
        { value: 'packaging', label: 'Packaging'},
        { value: 'shelf', label: 'Shelf'},
        { value: 'sent_to_germany', label: 'Shipped'}
      ]
    }
  }
};
</script>
